/* ============================================================
   GB PDP sticky-ATC blend-in (mobile only)
   ============================================================
   Behaviour:
   - The sticky bar appears ONLY when you scroll down to the Add-to-Cart
     section: the trigger is the on-page ATC form `.productView-form.product-form`
     — specifically when its TOP reaches the folded header's bottom edge (where
     the bar docks). Not a generic scroll threshold, not "after scrolling past".
   - At that line the sticky bar blends in (fade + a short slide up into place),
     so it reads as the Add-to-Cart flowing up into the sticky bar while the
     real on-page button keeps scrolling under the header naturally.
   - The on-page ATC is NEVER hidden or removed. Scroll back up above the line
     and the sticky bar blends out; the on-page ATC is untouched in its place.
   - The sticky bar's own markup/design is NOT changed — only its entrance.
   - Mobile (<768px) only. On desktop this module no-ops and the stock sticky
     behaviour is untouched.
   ============================================================ */
(function () {
  'use strict';

  function isMobile() { return window.matchMedia('(max-width: 767px)').matches; }

  var started = false;
  function init() {
    if (started) return;
    // Anchor = the MAIN PDP add-to-cart form. Scope to .productView so we never
    // grab a product-card's duplicate id="product-add-to-cart" (our gb-card2
    // cards reuse it) or a quick-shop popup form.
    var form = document.querySelector('.productView .productView-form.product-form') ||
               document.querySelector('.productView-form.product-form');
    var sticky = document.querySelector('sticky-add-to-cart.gb-sticky-top');
    if (!form || !sticky || !isMobile()) return; // may retry on 'load'
    // The real on-page ATC button (scoped to the main form, so not a card's
    // duplicate id) and the sticky bar's ATC button — we fire the blend exactly
    // when the on-page button reaches where the sticky's button will sit, so
    // the two line up and read as one.
    var pageBtn = form.querySelector('.product-form__submit') ||
                  form.querySelector('[data-btn-addToCart]') ||
                  form.querySelector('button[name="add"]');
    var stickyBtn = sticky.querySelector('.sticky-actions .button');
    if (!pageBtn || !stickyBtn) return;
    started = true;

    document.body.classList.add('gb-morph-proto');

    // Scoped styles: neutralise the stock .show-sticky toggle in proto mode and
    // drive visibility ourselves, with a fade + slide-up entrance. Nothing here
    // restyles the bar; it only animates opacity/transform on the whole bar.
    var css = document.createElement('style');
    var EASE = 'cubic-bezier(.25,.8,.25,1)'; // soft
    css.textContent =
      'body.gb-morph-proto .productView-stickyCart{' +
        'transition:opacity .16s ' + EASE + '!important;' +
        'opacity:0;visibility:hidden;pointer-events:none;}' +
      'body.gb-morph-proto .productView-stickyCart.show-sticky{opacity:0;visibility:hidden;}' + // kill stock toggle
      'body.gb-morph-proto .productView-stickyCart.gb-blend-in{' +
        'opacity:1!important;visibility:visible!important;pointer-events:auto!important;}' +
      // while the clone is morphing, hide the sticky bar's own ATC so only the
      // clone is seen reshaping into its slot; the rest of the bar fades in.
      'body.gb-morph-proto .productView-stickyCart.gb-morphing .sticky-actions{opacity:0;}' +
      // The transient clone that reshapes the on-page button into the slot.
      // It lives on <body>, outside the .productView scope, so the mint-skin
      // CSS does not reach it — pin the sticky ATC skin here explicitly so it
      // never flashes the theme's default dark-green/white button style.
      '.gb-morph-clone{position:fixed;margin:0;z-index:98;pointer-events:none;box-sizing:border-box;' +
        'background:#94F6A6!important;border:1px solid #00AC45!important;color:#141E2F!important;font-weight:400!important;font-size:14px!important;' +
        'transition:top .22s ' + EASE + ',left .22s ' + EASE + ',width .22s ' + EASE + ',height .22s ' + EASE + ';}' +
      '.gb-morph-clone *{color:#141E2F!important;}';
    document.head.appendChild(css);

    function headerBottom() {
      var h = document.querySelector('[data-gb-mobile-header]');
      if (h && h.offsetHeight) return Math.max(0, Math.round(h.getBoundingClientRect().bottom));
      var sh = document.querySelector('sticky-header');
      return sh ? sh.offsetHeight : 0;
    }

    var shown = false;

    function removeClone() {
      var c = document.querySelector('.gb-morph-clone');
      if (c && c.parentNode) c.parentNode.removeChild(c);
    }

    function show() {
      if (shown) return;
      shown = true;
      sticky.style.top = headerBottom() + 'px';
      sticky.style.bottom = 'auto';

      // Measure the on-page button (start) and the sticky slot (end). Reveal the
      // bar first so the slot has a real rect, but hide its own ATC so only the
      // reshaping clone is seen landing in it.
      var first = pageBtn.getBoundingClientRect();
      sticky.classList.add('gb-blend-in', 'gb-morphing');
      var last = stickyBtn.getBoundingClientRect();

      // The real on-page ATC is NOT touched — this clone is a transient visual.
      removeClone();
      var clone = pageBtn.cloneNode(true);
      clone.classList.add('gb-morph-clone');
      clone.removeAttribute('id');
      clone.style.top = first.top + 'px';
      clone.style.left = first.left + 'px';
      clone.style.width = first.width + 'px';
      clone.style.height = first.height + 'px';
      document.body.appendChild(clone);

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          clone.style.top = last.top + 'px';
          clone.style.left = last.left + 'px';
          clone.style.width = last.width + 'px';
          clone.style.height = last.height + 'px';
        });
      });

      // When the clone lands, reveal the real sticky ATC and drop the clone in
      // the same frame. The on-page ATC now shares the sticky skin, so the
      // swap is invisible — no fade, no blank gap.
      var done = function () {
        clone.removeEventListener('transitionend', done);
        sticky.classList.remove('gb-morphing');
        removeClone();
      };
      clone.addEventListener('transitionend', done);
      setTimeout(done, 300); // safety net
    }

    function hide() {
      if (!shown) return;
      shown = false;
      sticky.classList.remove('gb-blend-in', 'gb-morphing'); // fades back out
      removeClone();
    }

    // Vertical offset of the sticky's ATC button from the top of the bar —
    // constant regardless of where the bar is positioned.
    function stickyBtnOffset() {
      return stickyBtn.getBoundingClientRect().top - sticky.getBoundingClientRect().top;
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        if (!isMobile()) { hide(); return; }
        // Fire when the on-page ATC button reaches the line where the sticky
        // bar's ATC button will sit (header bottom + the button's offset in the
        // bar). At that instant the two buttons align, so the sticky blends in
        // exactly as the on-page one arrives — they read as one.
        var dockedBtnTop = headerBottom() + stickyBtnOffset();
        if (pageBtn.getBoundingClientRect().top <= dockedBtnTop) show(); else hide();
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Retry after full load in case the product form / sticky hydrate late.
  window.addEventListener('load', init);
})();
